import api from '../services/api';
import { createBaseModule } from './base';

export default createBaseModule( {
  state: {

  },
  mutations: {

  },
  actions: {
    async fetchSlider({ commit, state }) {

     if (state.data)
       return;

      try {
        commit('SET_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await api.get('api/mainpage/slider/');
        commit('SET_DATA', {data:response.data.data.items});
        commit('SET_ERROR', null);
      } catch (error) {
        commit('SET_ERROR', error.message?error.message:'Ошибка при загрузке');
      } finally {
        commit('SET_LOADING', false);
      }
    }
  },
  getters: {
    slider: state => state.data,
    sliderLoading: state => state.loading,
    sliderError: state => state.error,
    sliderLoaded: state => state.loaded,
  }
})